import axios from "axios";

const API = axios.create({
   baseURL: process.env.NODE_ENV === "development" ? "http://localhost:8000" : process.env.REACT_APP_API_URL
});


export default {

   getEditions: async() => {
      const { data } = await API.get( "/dictionaries/editions" );
      return data;
   },

   getUDTopics: async( name, cancelToken ) => {
      const { data } = await API.get( `/ud-browser/editions/${ name }/topics`, { cancelToken });
      return data;
   },

   getUDGroups: async( name, cancelToken ) => {
      const { data } = await API.get( `/ud-browser/editions/${ name }/groups`, { cancelToken });
      return data; 
   },

   getUDFilters: async( name, cancelToken ) => {
      const { data } = await API.get( `/ud-browser/editions/${ name }/filters`, { cancelToken });
      return data;
   },

   getUDCompareTopics: async( name1, name2, cancelToken ) => {
      const { data } = await API.get( `/ud-browser/compare/${ name1 }/${ name2 }/topics`, { cancelToken });
      return data;
   },

   getUDCompareGroups: async( name1, name2, cancelToken ) => {
      const { data } = await API.get( `/ud-browser/compare/${ name1 }/${ name2 }/groups`, { cancelToken });
      return data;
   },

   getUDCompareFilters: async( name1, name2, cancelToken ) => {
      const { data } = await API.get( `/ud-browser/compare/${ name1 }/${ name2 }/filters`, { cancelToken });
      return data;
   },

   getCharts: async( params, cancelToken ) => {
      const { data } = await API.get( "/charts", {
         params,
         cancelToken
      });

      return data;
   },

   getCompareCharts: async( params, cancelToken ) => {
      const { data } = await API.get( "/charts/compare", {
         params,
         cancelToken
      });

      return data;
   },

   getAZZKULatestEdition: async() => {
      const { data } = await API.get( `/azzku-browser/latest-edition` );
      return data;
   },

   getAZZKUTopics: async( edition_id ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/topics` );
      return data;
   },

   getAZZKUVoivodeships: async( edition_id ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/voivodeships` );
      return data;
   },

   getAZZKUAvailableTerritories: async( edition_id, variable_id, relation_id ) => {
      const { data } = await API.post( `/azzku-browser/editions/${ edition_id }/available-territories`, {
         variable_ids: variable_id ? [ variable_id ] : [],
         relation_ids: relation_id ? [ relation_id ] : []
      });
      
      return data.territories;
   },

   getAZZKUIndustries: async( edition_id ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/industries` );
      return data;
   },

   getAZZKUProfessions: async( edition_id ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/professions` );
      return data;
   },

   searchAZZKUProfessions: async( edition_id, q ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/professions/search`, {
         params: { q }
      });

      return data;
   },

   getAZZKURelations: async( edition_id, variable_id ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/relations`, {
         params: { variable_id }
      });
      return data;
   },

   getAZZKUYears: async( edition_id, params, cancelToken ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/years`, {
         params,
         cancelToken
      });
      return data;
   },

   getAZZKUChartData: async( edition_id, params, cancelToken ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/chart-data`, {
         params,
         cancelToken
      });

      return data;
   },

   getAZZKUTopData: async( edition_id, params, cancelToken ) => {
      const { data } = await API.get( `/azzku-browser/editions/${ edition_id }/top`, {
         params,
         cancelToken
      });

      return [ data ];
   }
}